import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const LABELS = { "cv-maker": "CV Maker", queue: "Antrian Review", "job-orders": "Job Order", candidates: "Kandidat", new: "Daftarkan Siswa", edit: "Ubah", "cv-builder": "Buat CV", pipeline: "Pipeline Rekrutmen", notifications: "Notifikasi", master: "Master Data", commercial: "Target & Fee", agreements: "Perjanjian", heatmap: "Heatmap", audit: "Audit Log", scorecard: "Scorecard Vendor", guide: "Panduan", mobile: "Mobile", "change-password": "Ganti Password" };

export const Breadcrumbs = () => {
  const { pathname } = useLocation();
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length === 0) return null;
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex items-center gap-1 text-xs text-muted-foreground mb-4 overflow-x-auto whitespace-nowrap">
      <Link to="/" className="hover:text-foreground flex items-center gap-1"><Home className="h-3.5 w-3.5" />Dashboard</Link>
      {parts.map((p, i) => { const to = "/" + parts.slice(0, i + 1).join("/"); const last = i === parts.length - 1; const label = LABELS[p] || (p.length > 12 ? "Detail" : p); return (
        <span key={to} className="flex items-center gap-1"><ChevronRight className="h-3 w-3" />{last ? <span className="text-foreground font-medium" aria-current="page">{label}</span> : <Link to={to} className="hover:text-foreground">{label}</Link>}</span>); })}
    </nav>
  );
};
